// Primero, instala la librería Signature Pad:
// npm install signature_pad --save
// npm uninstall signature_pad
// npm install signature_pad@3.0.0-beta.4 --save
// npm install @types/signature_pad --save-dev

import { Component, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-firma-pad',
  templateUrl: './firma-pad.component.html',
  styleUrls: ['./firma-pad.component.css']
})
export class FirmaPadComponent implements AfterViewInit {

   @ViewChild('signatureCanvas') signatureCanvas!: ElementRef;
   signaturePad: any;
   
   @Output() signatureComplete = new EventEmitter<string>();
   @Output() onCancel:EventEmitter<number> = new EventEmitter();
   @Input() titulo:string = 'Firma Cliente';
   
   constructor() { }
 
   ngAfterViewInit() {
     this.initializeSignaturePad();
   }
 
   private initializeSignaturePad() {
     const canvas = this.signatureCanvas.nativeElement;
     
     // Ajustar el canvas al tamaño del contenedor
     this.resizeCanvas();
 
     this.signaturePad = new SignaturePad(canvas, {
       backgroundColor: 'rgb(255, 255, 255)',
       penColor: 'rgb(0, 0, 0)'
     });
   }
 
   private resizeCanvas() {
     const canvas = this.signatureCanvas.nativeElement;
     const ratio = Math.max(window.devicePixelRatio || 1, 1);
     const parentElement = canvas.parentElement;
     
     canvas.width = parentElement.offsetWidth * ratio;
     canvas.height = parentElement.offsetHeight * ratio;
     canvas.getContext('2d').scale(ratio, ratio);
     
     // Limpia el canvas cuando se redimensiona
     this.clearSignature();
   }
 
   clearSignature() {
     if (this.signaturePad) {
       this.signaturePad.clear();
     }
   }
 
   saveSignature() {
     if (this.signaturePad && !this.signaturePad.isEmpty()) {
       // Obtener la firma como imagen base64
       const signatureData = this.signaturePad.toDataURL();
       this.signatureComplete.emit(signatureData);
       return signatureData;
     }
     return null;
   }
 
   // Se puede llamar cuando cambia la orientación del dispositivo
   onResize() {
     this.resizeCanvas();
   }

   cancelar() {
      this.onCancel.emit(0);
    }
 }